// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2PAvt","navigation":"style_navigation__1B0C5","detailContainer":"style_detailContainer__2tXaG"};